import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import Maps from './Maps';
import PlayersTab from './tournament/PlayersTab';
import RulesTab from './tournament/RulesTab';

const ExternalTournamentView = ({ tournament, players, tournamentId }) => {
  return (
    <Tabs defaultValue="rules" className="w-full">
      <TabsList className="w-full justify-start overflow-x-auto">
        <TabsTrigger value="rules">Rules</TabsTrigger>
        {!tournament.hideMaps && <TabsTrigger value="maps">Maps</TabsTrigger>}
        <TabsTrigger value="players">Players</TabsTrigger>
      </TabsList>

      <TabsContent value="rules" className="space-y-6">
        {tournament.link && (
          <Card className="border-border/60 bg-background/40">
            <CardHeader>
              <CardTitle className="font-display text-xl">{tournament.name}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              {tournament.description && (
                <p className="text-sm text-muted-foreground sm:text-base">
                  {tournament.description}
                </p>
              )}
              <Button asChild>
                <a href={tournament.link} target="_blank" rel="noreferrer noopener">
                  <ExternalLink className="h-4 w-4" />
                  Visit tournament site
                </a>
              </Button>
            </CardContent>
          </Card>
        )}
        <RulesTab html={tournament.rules} />
      </TabsContent>

      {!tournament.hideMaps && (
        <TabsContent value="maps">
          <Maps tournamentId={tournamentId} />
        </TabsContent>
      )}

      <TabsContent value="players">
        <PlayersTab players={players} />
      </TabsContent>
    </Tabs>
  );
};

export default ExternalTournamentView;
